import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  public consumers: string;
  public groupedOrders: string;
  public login: string;
  public logout: string;
  public orders: string;
  public refreshTokenEP: string;
  public search: string;
  public updateConsumerService: string;
  public deleteConsumerService: string;
  public user: string;
  public userDetail: string;
  public updateOrderEP: string;
  public deleteOrderEP: string;
  public searchModel: string;

  constructor() {
    this.consumers = environment.apiUrl + '/v2/consumers/manage/';
    this.groupedOrders = environment.apiUrl + '/v2/orders/tickets_grouped/';
    this.login = environment.apiUrl + '/v2/auth/login/';
    this.logout = environment.apiUrl + '/v2/auth/logout/';
    this.orders = environment.apiUrl + '/v2/orders/';
    this.refreshTokenEP = environment.apiUrl + '/v2/auth/token/refresh/';
    this.search = environment.apiUrl + '/v2/orders/search/';
    this.updateConsumerService =
      environment.apiUrl + '/v2/consumer_services/upsert_multiple/';
    this.deleteConsumerService =
      environment.apiUrl + '/v2/consumer_services/delete_multiple/';
    this.user = environment.apiUrl + '/v2/users/me/';
    this.userDetail = environment.apiUrl + '/v2/users/';
    this.updateOrderEP = environment.apiUrl + '/v2/orders/update_multiple/';
    this.deleteOrderEP = environment.apiUrl + '/v2/orders/delete_multiple/';
    this.searchModel = environment.apiUrl + '/v2/search/';
  }
}
